import { render } from "./packlist.vue?vue&type=template&id=1cc1b428"
import script from "./packlist.vue?vue&type=script&lang=js"
export * from "./packlist.vue?vue&type=script&lang=js"

import exportComponent from "F:\\chatpc\\chatadmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__